import toString from "./component-library282.mjs";
var idCounter = 0;
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}
export {
  uniqueId as default
};
